/** Il messaggio di un errore nella lingua dell'utente: la chiave del backend tradotta, altrimenti il suo testo. */
import { isChiaveMessaggio } from "@qa/shared";
import { ApiError } from "../api/client";
import i18n from "./index";

export function messaggioErrore(e: unknown, ripiego?: string): string {
  if (e instanceof ApiError && isChiaveMessaggio(e.key)) return i18n.t(`errori.${e.key}`, e.params ?? {}) as string;
  if (e instanceof ApiError && e.status === 501) return i18n.t("errore.nonAncora");
  if (e instanceof ApiError && e.code === "validation") return i18n.t("errore.datiNonValidi");
  if (e instanceof ApiError && e.message) return e.message;
  return ripiego ?? i18n.t("errore.generico");
}

/** Un messaggio del catalogo per chiave (es. `?errore=<chiave>` del login SSO); testo libero se non è una chiave. */
export function testoChiave(k: string | null | undefined, params?: Record<string, string | number>): string {
  if (!k) return "";
  return isChiaveMessaggio(k) ? (i18n.t(`errori.${k}`, params ?? {}) as string) : k;
}
